import React from 'react';

import ProjectFilterActive from '../ProjectFilterActive';
import ProjectFilterFields from '../ProjectFilterFields';
import ProjectsFilterClearAll from '../ProjectsFilterClearAll';

import './ProjectsSubFilter.scoped.scss';

const ProjectsSubFilter = () => {
  return (
    <ProjectFilterActive>
      <div className="projects-sub-filter">
        <ProjectFilterFields />
        <ProjectsFilterClearAll />
      </div>
    </ProjectFilterActive>
  );
};

export default ProjectsSubFilter;
